import React from 'react'

import Button from '../../common/components/Button';

export default function CrumplePopHubDownload() {
    const downloadUrl = React.useMemo(() => {
        const platform = getPlatform();
        if (platform == 'Windows'){
            return 'https://cdn.borisfx.com/borisfx/store/suitemanager/installers/Boris%20FX%20Hub%20Installer_MigrateCPop-1.1.23-win.zip';
        }
        else{
            return 'https://cdn.borisfx.com/borisfx/store/suitemanager/installers/Boris%20FX%20Hub%20Installer_MigrateCPop-1.1.23-mac.zip';
        }
    }, []);

    const handleDownload = () => {
        window.location.href = downloadUrl;
    }


    return (
        <div>
            <Button className='btn btn-new' label='Download Boris FX Hub' onClick={handleDownload} />
        </div>
    )
}

const getPlatform = () => {
    var os = window.navigator.platform.toLowerCase();
    if (os.includes('win')) return 'Windows'
    else if (os.includes('mac')) return 'macOS'
    else if (os.includes('linux')) return 'Linux'
    else return null;
}
